<template>
  <PageLayout title="Tlačítka">
    <div class="d-flex mx-n2 mb-6">
      <v-btn color="primary" class="c-btn mx-2">
        Primary
      </v-btn>
      <v-btn color="primary" class="c-btn mx-2">
        Primary with icon
        <v-icon right>mdi-plus</v-icon>
      </v-btn>
      <v-btn color="primary" class="c-btn mx-2" disabled>
        Primary disabled
      </v-btn>
    </div>
    <div class="d-flex mx-n2 mb-6">
      <v-btn outlined color="amber" class="c-btn mx-2">
        Secondary
      </v-btn>
      <v-btn outlined color="amber" class="c-btn mx-2">
        Secondary with icon
        <v-icon right>mdi-arrow-right</v-icon>
      </v-btn>
      <v-btn outlined color="amber" class="c-btn mx-2" disabled>
        Secondary disabled
      </v-btn>
    </div>
    <div class="d-flex mx-n2 mb-6">
      <v-btn color="white" class="c-btn mx-2">
        Tertiary
      </v-btn>
      <v-btn color="white" class="c-btn mx-2">
        Teriary with icon
        <v-icon right>mdi-arrow-right</v-icon>
      </v-btn>
      <v-btn color="white" class="c-btn mx-2" disabled>
        Tertiary disabled
      </v-btn>
    </div>
    <div class="d-flex mx-n2 mb-6">
      <v-btn color="facebook" class="mx-2 c-btn white--text">
        <v-icon left>mdi-facebook</v-icon>
        Facebook
      </v-btn>
    </div>
    <div class="d-flex mx-n2 mb-6">
      <v-btn small text rounded class="mx-2">
        <v-icon left>mdi-plus-circle-outline</v-icon>
        Add
      </v-btn>
      <v-btn small text rounded class="mx-2" disabled>
        <v-icon left>mdi-plus-circle-outline</v-icon>
        Add disabled
      </v-btn>
      <v-btn small text rounded class="mx-2">
        <v-icon left>mdi-refresh</v-icon>
        Update
      </v-btn>
      <v-btn small text rounded class="mx-2" disabled>
        <v-icon left>mdi-refresh</v-icon>
        Update disabled
      </v-btn>
    </div>
  </PageLayout>
</template>

<script>
import PageLayout from "@/components/page/design-system/PageLayout.vue"

export default {
  components: {
    PageLayout,
  },
}
</script>
